import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import pagesRouting from '@pages/pages-routing'

import {wrapperRouter} from '@utils'

Vue.use(Router)


@wrapperRouter
class RouterClazz extends Router{
  constructor(...args){
    super(...args);
  }
}

export default new RouterClazz({
  mode: 'history',
  base: '/',
  routes: [
    ...pagesRouting
  ]
})

